export default {
  site: {
    name: "好坏动漫",
    tagline: "精选推荐与深度评测平台",
    description: "好坏动漫是你发现优质动漫与避坑劣质动漫的最佳指南。我们提供专业的好坏动漫评测、排行榜与推荐列表，帮助动漫爱好者快速筛选值得一看的作品。",
  },
  nav: {
    home: "首页",
    categories: "分类",
    rankings: "排行榜",
    about: "关于我们",
  },
  home: {
    heroTitle: "发现优质动漫",
    heroSubtitle: "告别踩雷，直击精品",
    heroDesc: "好坏动漫为你提供最专业的动漫评测与推荐指南，让每一部作品都值得你的时间。",
    searchPlaceholder: "搜索你想了解的动漫...",
    featuredTitle: "🔥 热门评测",
    featuredSubtitle: "编辑精选，不容错过的好动漫",
    categoriesTitle: "📂 按类型探索",
    categoriesSubtitle: "找到你喜欢的动漫类型",
    rankingsTitle: "🏆 好坏排行榜",
    rankingsSubtitle: "一目了然的好坏对比",
    latestTitle: "📝 最新评测",
    latestSubtitle: "新鲜出炉的深度评测",
    viewMore: "查看更多",
    goodBad: "好/坏",
  },
  category: {
    allTitle: "全部评测",
    subTitle: "按分类浏览动漫评测",
    noResults: "暂无该分类的评测文章",
  },
  article: {
    rating: "评分",
    good: "优点",
    bad: "缺点",
    verdict: "总结",
    relatedArticles: "相关评测",
    backToList: "返回列表",
    author: "作者",
    publishDate: "发布时间",
    category: "分类",
    shareTitle: "分享这篇文章",
  },
  about: {
    title: "关于好坏动漫",
    intro: "品牌介绍",
    introText: "好坏动漫成立于2024年，是一群热爱动漫的资深观众创立的独立评测平台。我们厌倦了千篇一律的赞美式影评，决定用最真实的角度，为每一部动漫打分——好的我们大方推荐，坏的我们直言不讳。",
    mission: "我们的使命",
    missionText: "帮助每一位动漫爱好者节省时间，用最短的时间找到最值得看的作品。我们相信，好的内容值得被看见，差的作品也应该被指出来。",
    reputation: "用户口碑",
    contact: "联系我们",
    contactDesc: "有任何建议、合作意向或想投稿评测？欢迎联系我们！",
    email: "电子邮箱",
    emailAddr: "contact@haohuai.me",
    wechat: "微信公众号",
    wechatId: "好坏动漫",
    bilibili: "B站账号",
    bilibiliId: "好坏动漫官方",
  },
  footer: {
    copyright: "© 2024 好坏动漫 版权所有",
    slogan: "好坏动漫 — 发现优质动漫，告别踩雷",
    links: "快速链接",
    followUs: "关注我们",
    contact: "联系方式",
  },
  breadcrumb: {
    home: "首页",
    category: "分类",
    about: "关于我们",
  },
  seo: {
    homeTitle: "好坏动漫·精选推荐与深度评测平台 | 发现优质动漫与避坑劣质动漫的最佳指南",
    homeDesc: "好坏动漫是你发现优质动漫与避坑劣质动漫的最佳指南。我们提供专业的好坏动漫评测、排行榜与推荐列表，帮助动漫爱好者快速筛选值得一看的作品，告别踩雷，直击精品。",
    homeKeywords: "好坏动漫,好坏动漫评测,好坏动漫排行榜,动漫推荐避坑,优质动漫筛选,动漫好坏对比,动漫评分指南",
    categoryTitle: "动漫分类 - 好坏动漫",
    categoryDesc: "按分类浏览好坏动漫的全部评测文章，找到你喜欢的动漫类型。热血战斗、奇幻冒险、日常喜剧、悬疑推理等全类型覆盖。",
    articleTitle: "动漫评测 - 好坏动漫",
    articleDesc: "好坏动漫深度评测文章，专业角度分析动漫的好坏优劣，帮助你做出最佳的观看选择。",
    aboutTitle: "关于我们 - 好坏动漫",
    aboutDesc: "了解好坏动漫的品牌故事、使命与团队。好坏动漫致力于为动漫爱好者提供最真实的评测与推荐。",
  },
};